import React from 'react';
import { Alert, Box, Button, List, ListItem, ListItemText, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
import routes from 'constants/routes';
import { LoadedQuotation, WizardSavedPassenger, WizardSavedService, isFullQuotation } from '../../types';
import { passengerSlotKindMeta } from '../../helpers/passengerSlotDisplay';
import { clearQuotationImportState } from '../../sessionStorage';

interface Props {
	saleOrderId: string;
	quotation: LoadedQuotation;
	savedPassengers: WizardSavedPassenger[];
	savedServices: WizardSavedService[];
}

export const StepSummary = ({ saleOrderId, quotation, savedPassengers, savedServices }: Props): JSX.Element => {
	const history = useHistory();

	const goToOrder = () => {
		clearQuotationImportState(saleOrderId);
		history.push(routes.salesOrder.edit.replace(':id', saleOrderId));
	};

	return (
		<Box>
			<Typography variant="h6" fontWeight={700} gutterBottom>
				Resumen
			</Typography>
			<Alert severity="success" sx={{ mb: 2 }}>
				Orden lista para revisión. Verificá proveedores, emisión GDS y detalles en la pantalla de la orden antes de
				operar.
			</Alert>

			<List dense>
				<ListItem>
					<ListItemText primary="Cotización" secondary={`#${quotation.id}`} />
				</ListItem>
				<ListItem>
					<ListItemText primary="Caso" secondary={quotation.crmTicket} />
				</ListItem>
				<ListItem>
					<ListItemText
						primary="Pasajeros cargados"
						secondary={
							savedPassengers
								.map((p) => {
									const prefix = p.slotKind ? `${passengerSlotKindMeta[p.slotKind].chipLabel}: ` : '';
									const role = p.slotLabel ? ` (${p.slotLabel})` : '';
									return `${prefix}${p.name} ${p.lastName}${role}`;
								})
								.join(' · ') || '—'
						}
					/>
				</ListItem>
				{isFullQuotation(quotation) && (
					<ListItem>
						<ListItemText
							primary="Servicios en cotización"
							secondary={`${quotation.airs?.length || 0} vuelo(s) · ${quotation.destination?.length || 0} destino(s)`}
						/>
					</ListItem>
				)}
				{savedServices.length > 0 && (
					<ListItem>
						<ListItemText
							primary="Servicios registrados en asistente"
							secondary={savedServices.map((s) => s.label).join(', ')}
						/>
					</ListItem>
				)}
			</List>

			<Alert severity="info" sx={{ mt: 2 }}>
				Podés ajustar precios, proveedores de tarifa/emisión y campos de NetSuite desde la orden habitual.
			</Alert>

			<Box mt={3} display="flex" justifyContent="flex-end">
				<Button variant="contained" color="primary" size="large" onClick={goToOrder}>
					Ir a la orden de venta
				</Button>
			</Box>
		</Box>
	);
};
